import { DatePicker } from "antd";
import dayjs from "dayjs";
import { FieldWrapper } from "../common/FieldWrapper";

export const DateInput = ({
  updateFormValues,
  updateChanges,
  label,
  helperText,
  error,
  field,
  required,
  info,
  value,
  ...props
}: {
  updateFormValues?: any;
  updateChanges?: any;
  label?: any;
  helperText?: any;
  error?: any;
  field?: any;
  required?: any;
  info?: any;
  value?: any;
}) => {
  const onChange = (date: any, dateString: any) => {
    const values = { [field]: dateString };
    updateFormValues(values);
    // changes
    if (updateChanges) updateChanges(values);
  };

  return (
    <div>
      <FieldWrapper
        {...{ label, helperText, error, field, required, info }}
        {...props}
      >
        <DatePicker onChange={onChange} value={value && dayjs(value)} />
      </FieldWrapper>
    </div>
  );
};
